// externals

import { NumericInput } from '@interstate/components/NumericInput';

// libraries
import { kebabCase } from '@makemydeal/dr-common-utils';

// consts/enums
import { ADJUSTED_RESIDUAL_ID, ADJUSTED_RESIDUAL_LABEL, ADJUSTED_RESIDUAL_VALUE_TESTID } from '../../constants';

// utils
import { StyledTextWithToggleGroupContainer, StyledTextWithToggleGroupText } from './StyledTextWithToggleGroup.styles';
import { useAdjustedResidualDisplayValue } from './hooks/useAdjustedResidualDisplayValue';

/**
 * Read-only display for the lease Adjusted Residual.
 * Adjusted Residual is already the Payment Services round-trip value
 * (`getAdjustedResidualValue`), so this is purely presentational.
 */
const AdjustedResidualDisplay = () => {
    const { value: displayValue, prefix } = useAdjustedResidualDisplayValue();

    return (
        <StyledTextWithToggleGroupContainer>
            <StyledTextWithToggleGroupText className="residual-field-container">
                <NumericInput
                    id={ADJUSTED_RESIDUAL_ID}
                    name={kebabCase(ADJUSTED_RESIDUAL_LABEL)}
                    label={ADJUSTED_RESIDUAL_LABEL}
                    value={displayValue}
                    readOnly={true}
                    inputPrefix={prefix}
                    data-testid={ADJUSTED_RESIDUAL_VALUE_TESTID}
                    allowDecimal={true}
                    size="sm"
                />
            </StyledTextWithToggleGroupText>
        </StyledTextWithToggleGroupContainer>
    );
};

export default AdjustedResidualDisplay;
